import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import type {
  APIResponse,
  MatterTrustCheck,
  MatterTrustCheckConnection,
} from "@/lib/types";

type MatterTrustCheckInput = Partial<MatterTrustCheck> & { matterId: string };

export const createMatterTrustCheckV1 = (data: MatterTrustCheckInput) =>
  authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterTrustCheck>
    >(`${baseFastApiMatterRoute}/trust-checks`, data)
    .then((res) => res.data);

export const updateMatterTrustCheckV1 = (data: MatterTrustCheckInput) =>
  authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterTrustCheck>
    >(`${baseFastApiMatterRoute}/trust-checks`, data)
    .then((res) => res.data);

export const deleteMatterTrustCheckV1 = (data: Pick<MatterTrustCheck, "id">) =>
  authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterTrustCheck>
    >(`${baseFastApiMatterRoute}/trust-checks/${data.id}`)
    .then((res) => res.data);

export const createMatterTrustCheckConnectionV1 = (
  data: Partial<MatterTrustCheckConnection>,
) =>
  authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterTrustCheckConnection>
    >(`${baseFastApiMatterRoute}/trust-checks/connections`, data)
    .then((res) => res.data);
